import { render, staticRenderFns } from "./FaqsDetail.vue?vue&type=template&id=7f27cba2&scoped=true"
import script from "./FaqsDetail.vue?vue&type=script&lang=ts"
export * from "./FaqsDetail.vue?vue&type=script&lang=ts"
import style0 from "./FaqsDetail.vue?vue&type=style&index=0&id=7f27cba2&lang=scss"
import style1 from "./FaqsDetail.vue?vue&type=style&index=1&id=7f27cba2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27cba2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\sandy\\Desktop\\EIOSYS\\Admin\\Alembic-Grow-Admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f27cba2')) {
      api.createRecord('7f27cba2', component.options)
    } else {
      api.reload('7f27cba2', component.options)
    }
    module.hot.accept("./FaqsDetail.vue?vue&type=template&id=7f27cba2&scoped=true", function () {
      api.rerender('7f27cba2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/faqs/components/FaqsDetail.vue"
export default component.exports